import { ERROR_CODE }            from '../00_assets' ;
import { api_response_t
       , DataFetcher
       , kde_api_user_t
       , PageFetcher
       , REST }                  from '../02_api' ;

import { MApp }                  from './10_model_app_global' ;


type fetcher_callback<T> = ( user: kde_api_user_t | null ) => DataFetcher<T> ;
type filter_callback<T> = ( data: T[] ) => T[] ;

export class CRUD<T extends { id: number }>
{
   get_api: ( user: kde_api_user_t ) => REST ;
   fetcher: fetcher_callback<T> ;
   filter?: filter_callback<T> ;

   constructor ( get_api: ( user: kde_api_user_t ) => REST
               , fetcher: fetcher_callback<T>
               , filter?: filter_callback<T> )
   {
     this.get_api = get_api ;
     this.fetcher = fetcher ;
     this.filter  = filter ;
   }

   data_for_page ( page: number = 0 )
   {
     const ret = this.data_fetcher.data_for_page( page ) ;

     return this.filter? 
            { data: this.filter( ret.data )
            , loading: ret.loading } as PageFetcher<T>
          : ret ;
   }

   get data_fetcher ( )
   {
     return this.fetcher( MApp( ).user ) ;
   }

   api ( )
   {
     const user = MApp( ).user
         , not_implemented = ( ) => Promise.resolve( { data: null, error: { code: -1, msg: 'Hacker!' } } ) ;

     return user?
            this.get_api( user )
          : { update: not_implemented
            , del:    not_implemented
            , add:    not_implemented
            } ;
   }

   on_add = ( entity: Partial< T > ) =>
     this.refresh_if_ok( this.api( ).add!( entity ) ) ;
   
   on_edit = ( entity: T, values: Partial< T > ) =>
      this.refresh_if_ok( this.api( ).update!( entity.id, values ) ) ;

   on_delete = ( entity: T ) =>
      this.refresh_if_ok( this.api( ).del!( entity.id ) ) ;


   refresh_if_ok = async ( request: Promise<api_response_t> ) =>
   {
     const ret = await request ;

     if ( ret.error.code === ERROR_CODE.NONE )
          this.data_fetcher.reload_last_page( ) ;

     return ret ;
   }
}